(function () {
  const checkbox = document.getElementById('warranty-checkbox');
  if (!checkbox) return;

  const priceDisplay = document.getElementById('warranty-price-display');
  const rate = window.WARRANTY_RATE;
  const productPrice = window.PRODUCT_PRICE;
  const variantId = window.WARRANTY_VARIANT_ID;

  // Affiche le prix calculé
  const warrantyPrice = ((productPrice * rate) / 100 / 100).toFixed(2);
  priceDisplay.textContent = warrantyPrice.replace('.', ',') + ' €';

  async function addWarranty() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { '_Garantie pour': document.title }
      })
    });
  }

// Récupère le nom du produit couvert
function getProductTitle() {
  const h1 = document.querySelector('h1.product-title');
  return h1 ? h1.innerText.trim() : document.title;
}

async function addWarranty() {
  const warrantyPriceFormatted = warrantyPrice + ' €';
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        'Produit couvert': document.querySelector('h1.product-title') 
                          ? document.querySelector('h1.product-title').innerText.trim() 
                          : document.title,
        'Durée': '1 an',
        'Prix réel': warrantyPriceFormatted
      }
    })
  });
}

async function removeWarranty() {
  const cart = await fetch('/cart.js').then(r => r.json());
  // On cherche la garantie liée à CE produit spécifique
  const item = cart.items.find(i =>
    i.variant_id == variantId &&
    i.properties &&
    i.properties['_product_ref'] == window.PRODUCT_ID
  );
  if (item) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }
}

  checkbox.addEventListener('change', function () {
    if (this.checked) {
      addWarranty();
    } else {
      removeWarranty();
    }
  });
})();